/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventSlashIDSDKLoadedV1
 */
export interface SDKEventSlashIDSDKLoadedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventSlashIDSDKLoadedV1
     */
    event_name: EventName;
}



/**
 * Check if a given object implements the SDKEventSlashIDSDKLoadedV1 interface.
 */
export function instanceOfSDKEventSlashIDSDKLoadedV1(value: object): value is SDKEventSlashIDSDKLoadedV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}

export function SDKEventSlashIDSDKLoadedV1FromJSON(json: any): SDKEventSlashIDSDKLoadedV1 {
    return SDKEventSlashIDSDKLoadedV1FromJSONTyped(json, false);
}

export function SDKEventSlashIDSDKLoadedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventSlashIDSDKLoadedV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
    };
}

export function SDKEventSlashIDSDKLoadedV1ToJSON(json: any): SDKEventSlashIDSDKLoadedV1 {
    return SDKEventSlashIDSDKLoadedV1ToJSONTyped(json, false);
}

export function SDKEventSlashIDSDKLoadedV1ToJSONTyped(value?: SDKEventSlashIDSDKLoadedV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
    };
}

